var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plus_svg__path-1",
    d: "M24 13.6H13.6V24h-3.2V13.6H0v-3.2h10.4V0h3.2v10.4H24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__icons-badges-variations",
    transform: "translate(-496 -311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__icons/plus",
    transform: "translate(496 311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "plus_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus_svg__path-1",
    id: "plus_svg__Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#plus_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus_svg__gray-70-4A4A4A",
    d: "M0 0h24v25H0z",
    transform: "translate(0 -1)"
  })))))));
};
export default SvgPlus;